export default "__VITE_ASSET__42XIvBjr__"